import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material';
import React, { FC, useEffect } from 'react';
import styles from './SiteDialog.module.css';
import { Close } from '@mui/icons-material';
import { useForm } from 'react-hook-form';

interface SiteDialogProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    setSiteAddress: (address: { address: string }) => void,
}

const SiteDialog: FC<SiteDialogProps> = ({ open, setOpen, setSiteAddress }) => {

    const { register, handleSubmit, formState: { errors }, reset } = useForm<{ siteAddress: string }>();

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            setSiteAddress(undefined);
            reset({ siteAddress: '' })
        }
    }, [open])

    const onSubmit = async (data: { siteAddress: string }) => {
        setSiteAddress({ address: data.siteAddress });
        setOpen(false);
    }

    return (<div>
        <Dialog fullWidth={true} maxWidth="sm" open={open} onClose={handleClose}>
            <DialogTitle>
                <IconButton onClick={handleClose} className={styles.close} color="secondary" data-testid="close-dialog" aria-label="Dialog dicht" component="span">
                    <Close />
                </IconButton>
                <span className={styles.title}>Kavel</span>
            </DialogTitle>
            <DialogContent>
                <form className={styles.siteForm} data-testid="site-address-form" onSubmit={handleSubmit(onSubmit)}>
                    <h2>Wat is het adres of perceel id van het project?</h2>
                    <div>
                        <TextField id="site-address"
                            fullWidth
                            variant="outlined"
                            className="form-input"
                            label="Adres of perceel id"
                            placeholder="Stationsstraat 12, Almere"
                            {...register('siteAddress', { required: { value: true, message: 'U moet adres of perceel id invullen.' }, maxLength: { value: 255, message: 'Adres of perceel id is te lang.' } })}
                        />
                        {errors.siteAddress && <p className="input-error">{errors.siteAddress.message}</p>}
                    </div>

                </form>
            </DialogContent>
            <DialogActions>
                <div className={styles.next}>
                    <Button color="primary" data-testid="project-name-submit" size="small" variant="contained" onClick={handleSubmit((d) => onSubmit(d))} >Volgende</Button>
                </div>
            </DialogActions>
        </Dialog>
    </div>
    )
};

export default SiteDialog;

